import React from "react";
import NavBar from "./NavBar";
import Footer from "./Footer";
import "./AboutUs.css";
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import PinterestIcon from '@material-ui/icons/Pinterest';

function AboutUs() {
	return (
		<div className="aboutUs">
			<NavBar page="aboutUs" />
				<div className="aboutUs__home">
					<h1 className="aboutUs__title"> About Us </h1>
					<p className="aboutUsP">
						Hello everyone, we warmly welcome you all to the 5-Star Restaurant! Here at 5 Star Restaurant, we are continually trying to improve our service and quality in order to give our customers the very best different culture food experience. Our online ordering website! So that our customers can relax at home and order their favourite, freshly cooked meals from 5-Star Restaurant in Devon Park. We’re loving about providing delicious and high-quality food, our main concern is to fulfill all our customer’s needs - we offer a selection of excellent food, prepared with the freshest and finest ingredients, to the highest requirement. We now have a website, where you can order online - choose from our complete menu, order your favourite dishes and have them delivered straight to your door!
					</p>

					<h1 className="aboutUs__title"> Follow Us on Social Media </h1>
					<div className="aboutUs__socialMediaIcons">
						<div className="aboutUs__socialMediaIcon">
							<FacebookIcon style={{fontSize: "40px", color: "#39569c"}}/>
							<div> Facebook </div>
						</div>
						<div className="aboutUs__socialMediaIcon">
							<TwitterIcon style={{fontSize: "40px", color: "#26A7DE"}}/>
							<div> Twitter </div>
						</div>
						<div className="aboutUs__socialMediaIcon">
							<InstagramIcon style={{fontSize: "40px", color: "#DD2A7B"}} />
							<div> Instagram </div>
						</div>
						<div className="aboutUs__socialMediaIcon">
							<PinterestIcon style={{fontSize: "40px", color: "rgb(189, 8, 28)"}} />
							<div> Pinterest </div>
						</div>
						<div className="aboutUsBlackBackground"> </div>
					</div>
				</div>
			<Footer />
		</div>
	)
}

export default AboutUs;